<template>
    <card shadow>
      <h5 class="h3 title">
        <span class="d-block mb-3">How do I use Potential?</span>
      </h5>
      <div v-if="getOrg.type === 'partner' || getOrg.type === 'agency'">
        Welcome to Potential! We are here to support your organization with resource postings, management of clients, statistics, and more! You can find all of these tabs on the left of the screen. If you need your Organization ID to add new users you can find it by clicking "Profile and Organization" on the left.
        <br><br>
        Please contact us at hello@findpotential.org with any questions or support!
      </div>
      <div v-else-if="getOrg.type === 'employer'">
        Welcome to Potential! We are here to support your hiring needs. By creating an account you have access to free job board postings, detailed filtering of our talent, contact information, and more. You can find all of these tabs on the left of the screen.
        <br><br>
        Please contact us at hello@findpotential.org with any questions or support!
      </div>
      <div v-else>
        Welcome to Potential! We are so happy to have you on our team. Here is where you can manage all aspects of Potential and those we serve.
        <br><br>
        Please contact your manager for any training needs!
      </div>
    </card>
</template>

<script>
import firebase from "@/config/firebase.js";

export default {
  name: "explainercard",
  data() {
    return {
    };
  },
  methods: {
    
  },
  computed: {
    getOrg() {
      console.log(this.$store.state.usermain.curOrg)
      return this.$store.state.usermain.curOrg;
    }
  },
  mounted() {

  }
};
</script>

<style scoped>
</style>
